import { X, Save } from "lucide-react";
import { VISIBILITY_META, VIS_FIREMNI } from "../../lib/taskVisibility";

const inputCls = "w-full px-3 py-2 border border-slate-300 text-sm rounded-sm bg-white focus:outline-none focus:ring-2 focus:ring-orange-600";

export function TaskForm({ editing, setEditing, onSave, onClose, team, jobs, tech }) {
    const locked = editing.is_auto;
    const types = Object.keys(VISIBILITY_META).filter((k) => !(tech && k === VIS_FIREMNI));
    const assigneeIsTech = team.find((m) => m.id === editing.assignee_id)?.role === "lead_technician";
    const conflict = editing.visibility === VIS_FIREMNI && assigneeIsTech;
    return (
        <div className="fixed inset-0 bg-slate-900/40 backdrop-blur-sm z-50 flex items-center justify-center p-4" onClick={onClose}>
            <div className="bg-white border-2 border-slate-900 max-w-lg w-full" onClick={(e) => e.stopPropagation()} data-testid="task-form">
                <div className="flex items-center justify-between px-6 py-4 border-b-2 border-slate-900">
                    <h2 className="font-display text-lg font-bold">{editing.id ? "Upravit úkol" : "Nový úkol"}</h2>
                    <button onClick={onClose} data-testid="task-form-close"><X className="w-5 h-5 text-slate-400 hover:text-slate-900" /></button>
                </div>
                <div className="p-6 space-y-4">
                    <div>
                        <label className="label-eyebrow block mb-1.5">Viditelnost</label>
                        <div className="grid grid-cols-3 gap-2" data-testid="task-visibility">
                            {types.map((k) => {
                                const m = VISIBILITY_META[k];
                                const active = editing.visibility === k;
                                return (
                                    <button key={k} type="button" disabled={locked} onClick={() => setEditing({ ...editing, visibility: k })}
                                            data-testid={`task-visibility-${k}`} title={m.hint}
                                            className={`px-2 py-2 text-xs font-semibold uppercase tracking-wider border rounded-sm transition-colors ${active ? m.cls : "border-slate-300 text-slate-500 hover:bg-slate-50"} ${locked ? "opacity-60 cursor-not-allowed" : ""}`}>
                                        {m.label}
                                    </button>
                                );
                            })}
                        </div>
                        <div className="text-[11px] text-slate-500 mt-1.5">
                            {locked ? "Automaticky vytvořený úkol je vždy Firemní." : VISIBILITY_META[editing.visibility]?.hint}
                        </div>
                    </div>
                    <div>
                        <label className="label-eyebrow block mb-1.5">Úkol *</label>
                        <input value={editing.title} onChange={(e) => setEditing({ ...editing, title: e.target.value })} data-testid="task-title" className={inputCls} />
                    </div>
                    <div>
                        <label className="label-eyebrow block mb-1.5">Popis</label>
                        <textarea rows={2} value={editing.description || ""} onChange={(e) => setEditing({ ...editing, description: e.target.value })} data-testid="task-description" className={`${inputCls} resize-none`} />
                    </div>
                    <div className="grid grid-cols-2 gap-3">
                        <div>
                            <label className="label-eyebrow block mb-1.5">Přiřadit</label>
                            <select value={editing.assignee_id || ""} onChange={(e) => setEditing({ ...editing, assignee_id: e.target.value })} data-testid="task-assignee" className={inputCls}>
                                <option value="">— Nikomu —</option>
                                {team.map((m) => <option key={m.id} value={m.id}>{m.name || m.email}</option>)}
                            </select>
                            {conflict && <div className="text-[11px] text-red-600 mt-1" data-testid="task-visibility-conflict">Firemní úkol nelze přiřadit vedoucímu technikovi.</div>}
                        </div>
                        <div>
                            <label className="label-eyebrow block mb-1.5">Termín</label>
                            <input type="date" value={editing.due_date || ""} onChange={(e) => setEditing({ ...editing, due_date: e.target.value })} data-testid="task-due" className={inputCls} />
                        </div>
                    </div>
                    <div>
                        <label className="label-eyebrow block mb-1.5">Zakázka (volitelně)</label>
                        <select value={editing.job_id || ""} onChange={(e) => setEditing({ ...editing, job_id: e.target.value })} data-testid="task-job" className={inputCls}>
                            <option value="">— Bez zakázky —</option>
                            {jobs.map((j) => <option key={j.id} value={j.id}>{j.title}</option>)}
                        </select>
                    </div>
                </div>
                <div className="flex gap-2 px-6 py-4 bg-slate-50 border-t border-slate-200 justify-end">
                    <button onClick={onClose} className="px-4 py-2 text-xs uppercase tracking-wider border border-slate-300 hover:bg-slate-100 rounded-sm">Zrušit</button>
                    <button onClick={onSave} disabled={conflict} data-testid="save-task"
                            className="px-4 py-2 text-xs uppercase tracking-wider font-semibold bg-orange-600 hover:bg-orange-700 disabled:opacity-50 text-white rounded-sm inline-flex items-center gap-1">
                        <Save className="w-3.5 h-3.5" /> Uložit
                    </button>
                </div>
            </div>
        </div>
    );
}
